import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { PreviewDocketDialogComponent } from '../dialogs/preview-docket-dialog/preview-docket-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'docket-number-account-reference-preview-cell',
    template: `
    <div class="flex flex-row justify-center items-start">
      <a
        matTooltip="View Contract"
        matTooltip-position="left"
        tooltipHideDelay="0"
        [routerLink]="['/docket/', id]"
      >
        {{ id }}
        <span *ngIf="accountsReference">({{ accountsReference }})</span>
      </a>
      <a
        *ngIf="id"
        matTooltip="Preview Contract"
        (click)="previewDocket($event)"
        class="ml-4 mt-1"
        matTooltip-position="left"
        tooltipHideDelay="0"
      >
        <mat-icon>pageview</mat-icon>
      </a>
    </div>
  `,
    standalone: true,
    imports: [MatTooltip, RouterLink, NgIf, MatIcon]
})
export class DocketNoAccRefPreviewCellComponent implements AgRendererComponent {
  id;
  accountsReference;

  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    if (params.value) {
      this.id = params.value.id;
      this.accountsReference = params.value.account_reference;
    }
  }

  refresh(params: any): boolean {
    this.id = params.value.id;
    this.accountsReference = params.value.account_reference;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}

  previewDocket(event) {
    event.stopPropagation();
    const dialogData = {
      docketId: this.id
    };

    const dialogRef = this.dialog.open(PreviewDocketDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((updateClicked) => {});
  }
}
